import request from '@/utils/request'

// 登录接口
export function toLogin(data) {
  return request({
    url: '/app-api/auth/toLogin/v1_0_0',
    method: 'post',
    data: data
  })
}
// 发送短信验证码(60秒一次)
export function sendSmsCode(data) {
  return request({
    url: '/app-api/service/common/sendSmsCode/v1_0_0',
    method: 'post',
    data: data
  })
}
// 忘记密码
export function toForgetPassword(data) {
  return request({
    url: '/app-api/auth/toForgetPassword/v1_0_0',
    method: 'post',
    data: data
  })
}
// 注册接口
export function toRegister(data) {
  return request({
    url: '/app-api/auth/toRegister/v1_0_0',
    method: 'post',
    data: data
  })
}
// 获取国家代码
export function getAllCountry(query) {
  return request({
    url: '/app-api/service/common/getAllCountry/v1_0_0',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js